import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Contact = () => {
  return (
    <section id="kontak" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
            Hubungi Kami
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Kami siap membantu mewujudkan pernikahan impian Anda
          </p>
        </div>

        <div className="grid-two-column" style={{ gap: '60px', alignItems: 'stretch' }}>
          {/* Contact Information */}
          <div>
            <h3 className="heading-2" style={{ marginBottom: '32px' }}>
              Informasi Kontak
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
              {/* Address */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <MapPin size={24} color="var(--text-primary)" />
                </div>
                <div>
                  <h4 className="heading-3" style={{ marginBottom: '8px' }}>Alamat</h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {companyInfo.address}
                  </p>
                  <a
                    href={companyInfo.mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-icon"
                    style={{ marginTop: '8px' }}
                  >
                    Lihat di Google Maps
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Phone size={24} color="var(--text-primary)" />
                </div>
                <div>
                  <h4 className="heading-3" style={{ marginBottom: '8px' }}>Telepon</h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {companyInfo.phone}
                  </p>
                  <a
                    href={companyInfo.whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-icon"
                    style={{ marginTop: '8px' }}
                  >
                    Chat via WhatsApp
                  </a>
                </div>
              </div>

              {/* Email */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Mail size={24} color="var(--text-primary)" />
                </div>
                <div>
                  <h4 className="heading-3" style={{ marginBottom: '8px' }}>Email</h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {companyInfo.email}
                  </p>
                </div>
              </div>

              {/* Operating Hours */}
              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{
                  width: '48px',
                  height: '48px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Clock size={24} color="var(--text-primary)" />
                </div>
                <div>
                  <h4 className="heading-3" style={{ marginBottom: '8px' }}>Jam Operasional</h4>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    Senin - Minggu: 09.00 - 21.00 WIB
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div style={{ marginTop: '40px' }}>
              <a
                href={companyInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Konsultasi Gratis Sekarang
              </a>
            </div>
          </div>

          {/* Map */}
          <div style={{ height: '100%', minHeight: '500px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.203847892749!2d108.19968631477486!3d-7.320981994697907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6f5f3b4c4c4c4d%3A0x4c4c4c4c4c4c4c4c!2sSetiamulya%2C%20Tamansari%2C%20Tasikmalaya%20Regency%2C%20West%20Java!5e0!3m2!1sen!2sid!4v1234567890123!5m2!1sen!2sid"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '0px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Annisa Wedding Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
